//import { useSelector } from "react-redux";
import React, { useEffect } from "react";

const apiKey = process.env.REACT_APP_API_RETURNING_KEY;

const CheckReturningGuest = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const makeAPICall = async () => {
    try {
      const dataToSend = {
        email: props.email,
        apiKey: apiKey,
        // Add more key-value pairs as needed
      };

      const destination = "https://api.amitywellness.com/api-returning.php";
      //console.log(destination);

      const response = await fetch(destination, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      const data = await response.json();
      const returning = JSON.parse(data.data);
      props.setGuestIsReturning(returning);
      props.setEmailAPICheck(false);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (props.emailAPICheck) {
      makeAPICall();
    }
  });

  return <React.Fragment></React.Fragment>;
};

export default CheckReturningGuest;
